import React, { useCallback } from 'react'
import { Column } from '@sencha/ext-modern'

import { ButtonComponent } from '@syncfusion/ej2-react-buttons'

import { getListFromValues } from 'tyan/public/utility'

const render = ({ _minibuttons: text, dataIndex, handler, buttonProps = {}, ...rest }) => {
	const renderInner = useCallback((value, { data }/* record */, dataIndex, cell, column) => {
		const { list } = getListFromValues(dataIndex, data)

		// console.log('renderInner:', list, buttonProps, rest)
		// console.log('  value:', value)
		// console.log('  record:', record)
		// console.log('  dataIndex:', dataIndex)
		// console.log('  cell:', cell)
		// console.log('  column:', column)

		return <div>
			{
				list && list.length
					? list.map((button, index) => {
						const _buttonProps = Object.entries(buttonProps).reduce((sum, [k, v]) => {
							sum[k] = typeof v === 'function'
								? v(button, data)
								: v
							return sum
						}, {})

						return <ButtonComponent key={`${button.text}_${index}`}
							cssClass='e-flat e-primary'
							style={{ padding: '6px 3px 4px 3px' }}
							{..._buttonProps}
							{...button.tooltip ? { title: button.tooltip } : {}}
							onClick={() => handler && handler(button, data)}
						>
							{button.text}
						</ButtonComponent>
					})
					: null
			}
		</div>
	}, [handler])

	// console.log('render:', text, dataIndex, handler, rest)
	return <Column {...{ dataIndex, text, /* cell: { bodyStyle: { padding: "0px 12px" } }, */ renderer: renderInner, ...rest }} menuDisabled />
}

export default render